// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qOCyff {
    position: relative;
    z-index: 99999;
    font-family: Madefor-Text, Madefor;
}

.k5W_vM,
.k5W_vM * {
    font-family: Madefor-Text, Madefor;
}

.RBEmL6 {
    display: none;
}

.qOCyff a {
    color: #000;
}

.qOCyff button {
    height: 36px;
    font-family: Madefor-Text, Madefor;
    font-size: 14px;
}

@media (max-width: 375px) {
    .qOCyff {
        font-family: Madefor-Text, Madefor;
        font-size: 13px;
    }
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `qOCyff`,
	"fontFallback": `k5W_vM`,
	"hidden": `RBEmL6`
};
export default ___CSS_LOADER_EXPORT___;
